import styles from "./multiselect.module.css";
import { GoTriangleDown } from "react-icons/go";
import { IoCloseOutline } from "react-icons/io5";
import { TbArrowBigLeftLineFilled, TbArrowBigRightLineFilled } from "react-icons/tb";
import React, { useState, useRef, useCallback, useEffect } from "react";
import { HiCheck } from "react-icons/hi";

function MultiSelect({disabled, label, placeholder, value, onValueChange, items, onUrlChange, nextUrl, previousUrl, pagination, required, dropdownWidth, removeBottomSelectedItems}) {

  const dropdownRef = useRef(null);
  const labelRef = useRef(null);
  const resultsRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(false);
  useOutsideAlerter(dropdownRef, labelRef);
  const [bottomPosition, setBottomPosition] = useState("");
  const [bottomPage, setBottomPage] = useState(window.innerHeight + window.scrollY);

  // useCallback atualiza o valor passado na outra página
  const handleChange = useCallback( newValue => {
    if (value.some((json) => areJsonsEqual(json, newValue))){
      popSelectedItem(newValue);
    }
    else {
      onValueChange([...value, newValue]);
    }
  }, [onValueChange, value]);

  const handleChangeAll = useCallback(() => {
    if (value.length === items.length){
      onValueChange([]);
    }
    else {
      onValueChange(items);
    }
  }, [onValueChange, value]);

  const handlePageChange = useCallback( value => {
    onUrlChange(value);
  }, [onUrlChange]);

  const popSelectedItem = useCallback( async val => {
    const newArr = await value.filter((item) => areEqualJSON(JSON.stringify(item), JSON.stringify(val)));
    await onValueChange(newArr);
  }, [onValueChange, value]);

  async function handleDropdownSize() {
    if (openDropdown === false && !disabled) {
      await setOpenDropdown(true);
      if (bottomPosition < bottomPage){
        await setBottomPage(window.innerHeight + window.scrollY);
        await setBottomPosition(dropdownRef.current.getBoundingClientRect().bottom+window.scrollY+dropdownRef.current.offsetHeight);
      }
    }
  }

  function useOutsideAlerter(ref, labelRef) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target) && labelRef.current && !labelRef.current.contains(event.target)) {
          setOpenDropdown(false);
          setBottomPosition(10);
          setBottomPage(100);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  function normalizeObject(obj) {
    if (typeof obj !== 'object' || obj === null) {
      return obj;
    }
  
    if (Array.isArray(obj)) {
      return obj.map(normalizeObject);
    }
  
    const keys = Object.keys(obj);
    keys.sort();
  
    const normalizedObj = {};
    for (const key of keys) {
      normalizedObj[key] = normalizeObject(obj[key]);
    }
  
    return normalizedObj;
  }
  
  function areEqualJSON(json1, json2) {
    const obj1 = JSON.parse(json1);
    const obj2 = JSON.parse(json2);
  
    const normalizedObj1 = normalizeObject(obj1);
    const normalizedObj2 = normalizeObject(obj2);
  
    return JSON.stringify(normalizedObj1) !== JSON.stringify(normalizedObj2);
  }

  function areJsonsEqual(json1, json2) {
    const jsonString1 = JSON.stringify(json1);
    const jsonString2 = JSON.stringify(json2);
  
    // Sort fields within the JSON strings alphabetically
    const sortedJsonString1 = jsonString1.split('').sort().join('');
    const sortedJsonString2 = jsonString2.split('').sort().join('');
  
    // Compare the sorted JSON strings
    return sortedJsonString1 === sortedJsonString2;
  }

  return (
    <div>
      <div className={styles.form}>
        <div style={{width: dropdownWidth ? dropdownWidth : ""}} className={(value.length === 0 && required) ? styles.dropdownNull : styles.dropdown}>
          { label === false ? "" : <p style={{borderBottom: value.length > 0 ? 0 : "", borderBottomLeftRadius: value.length > 0 ? 0 : ""}}>{label}</p> }
          <div ref={labelRef} className={styles.dropdownLabel} style={{color: value === "" ? "" : "var(--text)", cursor: disabled ? "default" : "pointer", borderBottomLeftRadius: !label ? "4px" : "", borderTopLeftRadius: !label ? "4px" : "", borderBottom: value.length > 0 ? 0 : "", borderBottomRightRadius: value.length > 0 ? 0 : "" }} onClick={() => {handleDropdownSize()}}>
            { placeholder }
            <GoTriangleDown size={14} color={ disabled ? "#c9c9c9" : "var(--text)"} />
          </div>
        </div>
        {
          openDropdown && !disabled ?
          <div className={styles.dropdownItems}>
            <div ref={dropdownRef} className={bottomPosition >= bottomPage ? styles.itemsTop : styles.items}>
              <div className={styles.item} style={{justifyContent: "center"}} onClick={() => handleChangeAll()}>
                <p style={{fontSize: "12pt", userSelect: "none", margin: "0", fontWeight: value.length === items.length ? "bold" : "", textAlign: "center"}}>Selecionar todos</p>
              </div>
              {
                items.map((v, index) => (
                <div key={index} className={styles.item} onClick={() => handleChange(v) }>
                  <p title={v.name} style={{fontSize: "12pt", margin: "0"}}>{v.name}</p>
                  <div className={value.some((json) => areJsonsEqual(json, v)) ? styles.checkedSquare : styles.checkSquare}>
                    {value.some((json) => areJsonsEqual(json, v)) ? <HiCheck color={"var(--background)"}/> : ""}
                  </div>
                </div>
                ))
              }
              { 
                pagination ?
                  <div className={styles.changePages}>
                    {previousUrl ? <TbArrowBigLeftLineFilled className={styles.changePageButtons} size={40} onClick={() => { handlePageChange(previousUrl) }}/> : <TbArrowBigLeftLineFilled color={"var(--input-background)"} size={40}/>}
                    {nextUrl ? <TbArrowBigRightLineFilled className={styles.changePageButtons} size={40} onClick={() => { handlePageChange(nextUrl) }}/> : <TbArrowBigRightLineFilled color={"var(--input-background)"} size={40}/>}
                  </div>
                : ""
              }
            </div>
          </div>
          :
          <></>
        }
        {
          removeBottomSelectedItems ? ""
          :
            <div>
              {
                value.length > 0 ? 
                <div className={styles.results} ref={resultsRef}>
                {(
                  value.map((val, index) => (
                    <div key={index} className={styles.result}>{val.name}<IoCloseOutline style={{cursor: "pointer"}} onClick={() => {popSelectedItem(val)}}/></div>
                  ))
                )}
                </div>
                : ""
              }
            </div>
        }
      </div>
    </div>
  );
}

export default MultiSelect;
